import { render, staticRenderFns } from "./PageListList.vue?vue&type=template&id=2a142ea4"
import script from "./PageListList.vue?vue&type=script&lang=js"
export * from "./PageListList.vue?vue&type=script&lang=js"
import style0 from "./PageListList.vue?vue&type=style&index=0&id=2a142ea4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports